import HealthcareProjectCard, {
  HealthcareProject,
} from './healthcare-project-card';
import styles from './healthcare-project-list.module.css';

export interface HealthcareProjectListProps {
  projects: HealthcareProject[];
}

export default function HealthcareProjectList({
  projects,
}: HealthcareProjectListProps) {
  return (
    <ul className={styles.projectList}>
      {projects &&
        projects.map((project, index) => (
          <li className={styles.projectList_item} key={index}>
            <HealthcareProjectCard {...project} />
          </li>
        ))}
    </ul>
  );
}
